/**
 * Constants that are shared across multiple parts of the application.
 */
export class AppConstants {
  // Key for preferred dashboard setting
  static readonly PREFERRED_DASHBOARD_LOCAL_STORAGE_KEY: string = 'preferred_dashboard';

  static readonly PREFERRED_BUDGET_DASHBOARD_LOCAL_STORAGE_KEY: string = 'preferred_budget_dashboard';
}
